<template>
  <div :key="refundable.text" class="refundability">
    <vb-icon
      class="refundability__icon"
      :name="refundable.icon"
      :color="sass(refundable.variant)"
      :size="14"
    />
    <span
      :class="`refundability__text refundability__text--${refundable.variant}`"
    >
      {{ refundable.text }}
    </span>
  </div>
</template>

<script>
  import { get_refundability } from '@bookingv3/utilities/mixins';

  export default {
    name: 'refundability',
    props: {
      cancellation: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      refundable() {
        const { refundable, text } = get_refundability(this.cancellation);
        return {
          text,
          icon: refundable ? 'check-circle' : 'lock_v2',
          variant: refundable ? 'success' : 'gray-600',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .refundability {
    line-height: normal;
    display: flex;
    align-items: center;
    font-size: $font-size-md;

    &__text {
      font-weight: $vb-font-weight-semibold;

      &--success {
        color: $success;
      }
    }

    &__icon {
      display: none;

      @include media-breakpoint-up(sm) {
        display: block;
        margin-right: 5px;
      }

      &--info {
        margin: 2px 0 0 5px;
      }
    }
  }
</style>
